import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "../../../api";
import * as billing from "../../../interfaces/screens/billing";

export const fetchInvoices = createAsyncThunk<billing.Invoice[]>(
  "billing/fetchInvoices",
  async (_, { rejectWithValue }) => {
    try {
      const invoices = await services.billing.getInvoices();
      return invoices;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchBillingCodes = createAsyncThunk<billing.BillingCode[]>(
  "billing/fetchBillingCodes",
  async (_, { rejectWithValue }) => {
    try {
      const codes = await services.billing.getBillingCodes();
      return codes;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchClaims = createAsyncThunk<billing.Claim[]>(
  "billing/fetchClaims",
  async (_, { rejectWithValue }) => {
    try {
      const claims = await services.billing.getClaims();
      return claims;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
